import styled from 'styled-components';
import variables from '@ingka/variables/design-tokens';
import cssIngka from '@ingka/variables/colours-css';

interface DividerProps {
  thick?: boolean;
}

export default styled.div`
  border-top: ${({ thick }): string =>
    thick
      ? `${variables.thicknessThick} solid ${cssIngka.colourNeutral7};`
      : `${variables.thicknessThin} solid ${cssIngka.colourNeutral3};`}
  );
  width: 100%;
  margin: ${({ thick }: DividerProps): string =>
    thick
      ? `0 ${variables.thicknessThick}`
      : `margin: 0 ${variables.thicknessThin}`}
  )
`;
